import React, { PureComponent } from "react";
import { View, StyleSheet } from "react-native";

import { Trade } from "emrn-hybrid/Trade";
import { Spacer } from "emrn-design/Spacer";
import { getGlobalConfigValue } from "emrn-hybrid/getGlobalConfigValue";

import { Dfcfzq } from "./Dfcfzq";
import { Submit } from "./Submit";
import { TitleBar } from "./TitleBar";
import { InputBox } from "./InputBox";
import { SwitchUserId } from "./SwitchUserId";
import { KeepOnlineTime } from "./KeepOnlineTime";

interface LoginDialogProps extends Partial<Trade.RequestLoginRequest> {
  onCancel: () => void;
  onLogin: (response: Trade.RequestLoginResponse) => void;
}

interface LoginDialogState {
  userId?: string;
  password?: string;
  onlineMinutes: number;
  serverAddress?: string;
}

export class TradeAccountLoginDialog extends PureComponent<
  LoginDialogProps,
  LoginDialogState
> {
  static displayName = "LoginDialog";

  constructor(props: LoginDialogProps) {
    super(props);
    this.state = { onlineMinutes: 180 };

    getGlobalConfigValue("trade_base_info", "trade_gateway_http_url").then(
      (serverAddress) => serverAddress && this.setState({ serverAddress })
    );
  }

  private handleUserIdChange = (userId: string) => {
    this.setState({ userId });
  };

  private handlePasswordChange = (password: string) => {
    this.setState({ password });
  };

  private handleLoginSuccess = (info: Trade.AccountInfo) => {
    this.props.onLogin({ info, hasLogin: true });
  };

  private handleChangeOnlineMinutes = (onlineMinutes: number) => {
    this.setState({ onlineMinutes });
  };

  private renderSwitchUserId = () => {
    return <SwitchUserId onSwictch={this.handleUserIdChange} />;
  };

  render() {
    const { onCancel } = this.props;
    const { userId, password, serverAddress, onlineMinutes } = this.state;
    return (
      <View style={styles.container}>
        <TitleBar title="交易登录" onCancel={onCancel} />
        <Dfcfzq />
        <View style={styles.main}>
          <InputBox
            key="userid"
            type="userid"
            value={userId || ""}
            placeholder="请输入资金账号"
            rightSlot={this.renderSwitchUserId}
            onChangeText={this.handleUserIdChange}
          />
          <InputBox
            key="password"
            type="password"
            value={password || ""}
            placeholder="请输入交易密码"
            onChangeText={this.handlePasswordChange}
          />
          <InputBox
            key="address"
            type="address"
            editable={false}
            value={serverAddress || ""}
          />
          <KeepOnlineTime
            minutes={onlineMinutes}
            onChange={this.handleChangeOnlineMinutes}
          />
          <Submit
            minutes={onlineMinutes}
            onSuccess={this.handleLoginSuccess}
            {...{ userId, password, serverAddress }}
          />
        </View>
        <Spacer size={50} />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    backgroundColor: "#fff",
  },
  main: {
    width: "100%",
    paddingHorizontal: 15,
  },
  switch: {
    color: "#3381e3",
    fontSize: 13,
  },
});
